import { axiosInstancePlano } from "../../../../core/api/planoAxios";
import { IEssaySchedule } from "../../model/essaySchedule";

export const getEssayTheme = async (day: string, scheduleId: string, essayContentId?: string): Promise<IEssaySchedule> => {
    const { data } = await axiosInstancePlano.get(`/cronograma/redacoes/${scheduleId}/${day}`);

    const matched = essayContentId && data.find((item: IEssaySchedule) => item.id === essayContentId);

    return matched || data[0];
};

export const concludeEssay = async (body: { cronogramaId: string, essayThemeId: string }) => {
    const { data } = await axiosInstancePlano.post(`/cronograma/redacoes/escrevendo/concluir`, body);

    return data;
};